module.exports = __webpack_public_path__ + "static/img/index-icon-2.dd296e33.png";